// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QIiE","rootNoMargin":"styles_rootNoMargin__27oUu"};